import './block.css';


export default function BlockSimple({id, blocks, parent_size, x_offset, y_offset, updateMDContent}){
    var data = blocks[id]
    var children = data["children"] || []

    let style = {} 

    let pct_to_px = (pct, parent_px) => {
        return ((pct / 100) * parent_px)
    }

    let cur_size = [
        pct_to_px(data.size[0], parent_size[0]),
        pct_to_px(data.size[1], parent_size[1]),
    ]

    if (cur_size[0] < 10 || cur_size[1] < 10) {
        console.log(data.title, "too small to render")
        return null
    }

    style["width"] = cur_size[0] + "px"
    style["height"] = cur_size[1] + "px"
    style["marginLeft"] = (pct_to_px(data.offset[0], parent_size[0]) - (parent_size[0] * x_offset)) + "px"
    style["marginTop"] = (pct_to_px(data.offset[1], parent_size[1]) - (parent_size[1] * y_offset)) + "px"
    style["fontSize"] = cur_size[1] / 10

    if (data.bg_color){
        style["backgroundColor"] = data.bg_color
    }

    let rendered_children = (children).map((child_index) => (
        <BlockSimple
            id={child_index}
            blocks={blocks}
            key={child_index}
            parent_size={cur_size}
            x_offset={0}
            y_offset={0}
            updateMDContent={updateMDContent}
        />
    ))

    let label_style = {"color": "black", "display": "block", "position": "absolute"}
    if (rendered_children.length === 0) {
        label_style['marginTop'] = (cur_size[1]/2) -  cur_size[1] / 10
        label_style['textAlign'] = 'center'
        label_style['width'] = "100%"
    }
    

    return (
        <div style={style} className='sb' onClick={(e) => {updateMDContent(id); e.stopPropagation()}}>
            <div style={label_style}>{data.title}</div>
            {rendered_children}
        </div>
    )
}